export default "__VITE_ASSET__B2rCSQ$5__"